import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import htmlEntDecoder from 'utils/htmlEntDecoder';
import './LastNewCard.scss';

const propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
};
const defaultProps = {};
function LastNewCard({ date, title, slug }) {
  return (
    <Link to={`/actualitat/${slug}`}>
      <div className="lastnewcard__container">
        <div className="lastnewcard--date">
          <h2>{date}</h2>
        </div>
        <div className="lastnewcard__content">
          <h2 className="line-clamp-5">{htmlEntDecoder(title)}</h2>
        </div>
      </div>
    </Link>
  );
}

LastNewCard.propTypes = propTypes;
LastNewCard.defaultProps = defaultProps;
export default LastNewCard;
